export default "__VITE_ASSET__4TWfGTbc__"